/*
 * FM Upsells (2026-10-21): what fits the Upsells storefront files (assets/oz-buy.js, assets/oz-upsells.js, copied
 * unchanged from the OzMobiles theme) to Impulse 7.4. Loaded by layout/theme.liquid wherever those files load.
 *
 *   Add to cart     the product form inside [data-oz-buy-root] (snippets/product-template.liquid) is bought by
 *                   OzBuy.buy('cart'), the one owner of adding to the cart: the variant on screen, every switched-on
 *                   Upsells row, the pop-up when a funnel has something to offer, then /cart. The tap and the submit
 *                   are both caught in the capture phase, before Impulse or any app script sees them, so nothing else
 *                   adds a second line. While OzBuy fills the cart (aria-busy on the button) the button shows
 *                   Impulse's own spinner (btn--loading).
 *   after the add   assets/oz-buy.js ends a buy by going to /cart. Frank's Add to cart stays on the product page and
 *                   opens the cart drawer instead, so OzBuy.navigate('/cart') does that and the shopper stays (no page
 *                   load): Impulse's drawer (Cart type "Drawer"; Rebuy is kept off by snippets/fm-rebuy-off.liquid)
 *                   gets its lines rebuilt (cart:build), its Upsells block re-rendered, and opens (cart:open). Should
 *                   Rebuy run again, its Smart Cart panel is opened instead; with neither, /cart as before.
 *   variant change  Impulse announces a variant with a non-bubbling `variantChange` on the product container, before it
 *                   sets the form's id; assets/oz-upsells.js listens for a bubbling `variant:changed` with
 *                   detail.variant. This re-announces it once the form holds the new id.
 *   cart block      a plus in the cart block (cart page or drawer) posts /cart/add.js with the block's section
 *                   (assets/oz-upsells.js, which hands the returned HTML to OzCart.apply): the block is swapped for the
 *                   new one and Impulse rebuilds its lines, discounts and subtotal (cart:build). After a quantity change
 *                   (Impulse's cart:updated) the block is fetched again, so it never offers against a cart that changed
 *                   under it.
 */
(function () {
  'use strict';

  var OzBuy = window.OzBuy = window.OzBuy || {};

  /* ---------- after the add: the cart drawer, no page load ---------- */
  function impulseDrawer() {
    return window.theme && theme.settings && theme.settings.cartType === 'drawer' ? document.getElementById('CartDrawer') : null;
  }
  function smartCart() {
    var rebuy = window.Rebuy;
    return rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function' ? rebuy : null;
  }
  OzBuy.navigate = function (url) {
    if (url !== '/cart') { window.location.href = url; return false; }
    try {
      if (impulseDrawer()) {
        refreshBlock();
        document.dispatchEvent(new CustomEvent('cart:build'));
        document.dispatchEvent(new CustomEvent('cart:open'));
        return true;
      }
      var rebuy = smartCart();
      if (rebuy) {
        if (rebuy.Cart && typeof rebuy.Cart.fetchCart === 'function') { rebuy.Cart.fetchCart(); }
        if (!rebuy.SmartCart.visible) { rebuy.SmartCart.show(); }
        return true;
      }
    } catch (e) { /* fall through to the cart page */ }
    window.location.href = url;
    return false;
  };

  /* ---------- Add to cart ---------- */
  function buyRoot(el) { return el && el.closest ? el.closest('[data-oz-buy-root]') : null; }
  function productSection(el) { return el.closest('[data-section-type="product"]'); }

  function buyFrom(root, event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (typeof OzBuy.buy !== 'function') { return; }
    var button = root.querySelector('[data-add-to-cart]');
    if (button && button.disabled) { return; }
    OzBuy.buy('cart', { section: productSection(root), button: button });
  }

  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-add-to-cart]') : null;
    var root = buyRoot(button);
    if (root) { buyFrom(root, event); }
  }, true);

  // Enter in a field of the form, or anything else that submits it
  document.addEventListener('submit', function (event) {
    var form = event.target;
    var root = buyRoot(form);
    if (root && /\/cart\/add/.test(form.getAttribute('action') || '')) { buyFrom(root, event); }
  }, true);

  function watchBusy() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-oz-buy-root] [data-add-to-cart]'), function (button) {
      if (button.__fmBusyWatched || !('MutationObserver' in window)) { return; }
      button.__fmBusyWatched = true;
      new MutationObserver(function () {
        button.classList.toggle('btn--loading', button.getAttribute('aria-busy') === 'true');
      }).observe(button, { attributes: true, attributeFilter: ['aria-busy'] });
    });
  }

  /* ---------- variant change ---------- */
  document.addEventListener('variantChange', function (event) {
    var container = event.target;
    var variant = event.detail && event.detail.variant;
    if (!variant || !container || !container.dispatchEvent) { return; }
    setTimeout(function () {
      container.dispatchEvent(new CustomEvent('variant:changed', { bubbles: true, detail: { variant: variant } }));
    }, 0);
  }, true);

  /* ---------- the cart page ---------- */
  function cartWrap() { return document.querySelector('[data-fm-up-cart]'); }

  function swapBlock(html) {
    var wrap = cartWrap();
    if (!wrap || typeof html !== 'string') { return false; }
    var holder = document.createElement('div');
    holder.innerHTML = html;
    var fresh = holder.querySelector('[data-fm-up-cart]');
    if (!fresh) { return false; }
    wrap.innerHTML = fresh.innerHTML;
    // assets/oz-upsells.js gives a new block its listeners on cart:rerendered
    wrap.dispatchEvent(new CustomEvent('cart:rerendered', { bubbles: true }));
    return true;
  }

  window.OzCart = window.OzCart || {
    apply: function (html) {
      if (!swapBlock(html)) { return false; }
      document.dispatchEvent(new CustomEvent('cart:build'));
      return true;
    }
  };

  // The Upsells block of the cart page or the drawer, fetched again from its section
  var refreshing = 0;
  function refreshBlock() {
    var wrap = cartWrap();
    var id = wrap && wrap.getAttribute('data-section-id');
    if (!id) { return; }
    var mine = ++refreshing;
    fetch('/cart?section_id=' + encodeURIComponent(id), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .then(function (html) { if (html && mine === refreshing) { swapBlock(html); } }, function () { /* keep the block as it is */ });
  }
  // a quantity changed or a line was removed in the drawer or on the cart page
  document.addEventListener('cart:updated', refreshBlock);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchBusy);
  } else {
    watchBusy();
  }
})();
